export default "__VITE_ASSET__eae61f86__"